import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['blueprint', 'pragmatic', 'relax', 'leap', 'evolution'],
        'live-casino': ['pragmatic', 'evolution'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'], // TODO: CONFIRM FOR BestOdds
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text: '#TOBEADDED', // TODO: ADD FOR BestOdds
        licence_number: '#TOBEADDED', // TODO: ADD FOR BestOdds
        licence_url: '#TOBEADDED', // TODO: ADD FOR BestOdds
        cookies_url: '#TOBEADDED', // TODO: ADD FOR BestOdds
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: '',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'BestOdds',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,
    reportsV2: false,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '0.01',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'BestOdds Events', // TODO: CONFIRM FOR BestOdds
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,
    staffCardDepositsEnabled: true,
    staffCardWithdrawalsEnabled: true,
    staffWithdrawalCardProvider: null,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'paysafe',
        apiKey: 'T1QtMzQ0MzYyOkItcDEtMC02N2M0ODhhMy0wLTMwMmMwMjE0NmE3NGU2ZTc4NWZlZDViODZjMGRkNDY1NTYyNTBmZGY3NjBjMzcwNzAyMTQxNjdkYzc3MTFjZjRiMmY4MjMyMTU1NTJlMWY0ZjNiZjkxZWYyYmE3',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003091362',
            EUR: '',
        },
        openBanking: 'yaspa',
    },

    userTitleOptional: false,
    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        AccountBalances: 'AccountBalances-BestOdds/AccountBalances',
        BackofficeReports: 'BackOfficeReports-BestOdds/DB-Casino',
        BonusEngine: 'BonusEngine-BestOdds/CampaignLevel',
        CasinoDashboard: 'CasinoDashboard-BestOdds/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-BestOdds/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-BestOdds/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-BestOdds/DailyKPI',
        RacecourseDashboard: 'Racecourse-BestOdds/RacecourseMediaGroupDashboard',
        RollingNetDeposits: 'RollingNetDeposits-BestOdds/RollingNetDeposits',
        SRGDashboard: 'SRGDashboard-BestOdds/DBAverageStakes',
        TransactionsDashboard: 'TransactionsDashboard-BestOdds/TransactionsMainDashboard',
    },
};
